import { ConfigDefaultService } from './../../../modules/shared/services/configuration-default.service';
import { ParseHelper } from './../../../modules/shared/parse.helper';
import { PhoneNumberFormatService } from './../../../modules/shared/services/phone-number-format.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CrmSettingModel } from '../../models/organization-settings.model';
import { ConfigurationService } from '../../configurationService';
import { CrmSettingsService } from 'src/app/modules/shared/services/crm-settings.service';
import { AppMainService } from 'src/app/app-main.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-c-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss']
})
export class CSettingComponent implements OnInit, OnDestroy {

  index = 0;
  configMenuOrdersItems = [];
  crmSettingFieldsList: CrmSettingModel[] = [];
  products = [
    {
      "id":1,
      "name":"Sample 1",
      "isActive":true,
      "children":[]
    },
    {
      "id":2,
      "name":"Sample 2",
      "isActive":true,
      "children":[]
    },
    {
      "id":3,
      "name":"Sample 3",
      "isActive":true,
      "children":[
        {
          "id":1,
          "name":"Children 1",
          "isActive":true,
        },
        {
          "id":2,
          "name":"Children 2",
          "isActive":true,
        },
      ]
    },
  ];
  expandedRows: {} = {};
  isSavedSearchSettings : boolean = false;
  accessControlData: any[] = [];
  accessControlDataCopy: any[] = [];
  selectedAccessControl: any;
  displaySettingsEdit: boolean = false;
  settingsOptionValues: any[] = [];
  selectedSettingOption: any;
  selectedSettings: any;

  allContactFormat: any[] = [
    { name: '##########', value: '9999999999', placeholder: 'Select Format'},
    { name: '###-###-####', value: '999-999-9999', placeholder: 'Select Format'},
    { name: '(###) ###-####', value: '(999) 999-9999', placeholder: 'Select Format'},
    { name: '(###)-###-####', value: '(999)-999-9999', placeholder: 'Select Format'},
    { name: '###.###.####', value: '999.999.9999', placeholder: 'Select Format'}
  ];

  accountChildLevels: any[] = [
    { name: '1 Level', value: "1", placeholder: 'Select Account Child Level'},
    { name: '2 Level', value: "2", placeholder: 'Select Account Child Level'},
    { name: '3 Level', value: "3", placeholder: 'Select Account Child Level'}
  ];

    /* Subject to unsubscribe */
    private ngUnsubscribe = new Subject<void>();

  constructor(
    private configurationService: ConfigurationService,
    private appMainService: AppMainService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private phoneNumberFormatService: PhoneNumberFormatService,
    private configDefaultService: ConfigDefaultService
  ) { }

  ngOnInit(): void {
    this.configMenuOrdersItems = [
      {
          label: 'Setting',
          icon: "pi pi-plus",
          command: () => { },
      },
    ];
    const thisRef = this;
    this.products.forEach(function(c) {
      thisRef.expandedRows[c.id] = true;
    });
    this.getSettingsData();
    this.savedSearchWorkflowSettings();

  }

  getIndex(event) {
    this.index = event.index;
  }

  getSettingsData(){
    this.configurationService.getCrmSettingFieldsList().subscribe({
      next: (response: CrmSettingModel[])=>{
        this.crmSettingFieldsList = response||[];
        this.crmSettingFieldsList = this.crmSettingFieldsList.filter(c=> !['fieldVisitTimeRange','VisitGeoMatchingRange','WorkbookKanbanViewMaxSelectableColumns','WorkbookListViewMaxSelectableColumns'].includes(c.code));
        if(this.crmSettingFieldsList?.length){
            this.crmSettingFieldsList.map(setting=>{
                setting.displayValue = setting?.value;
                if(setting.code=='ContactTemplate' && setting.value){
                    setting.displayValue = this.allContactFormat.find(f=> f.value==setting.value)?.name||setting.value;
                }

                if(setting.code=='parentChildLevel'){
                    setting.enabled = true;
                    setting.displayValue = this.accountChildLevels.find(f=> f.value==setting.value)?.name||this.accountChildLevels[0].name;
                }
            })
        }
      },
      error: (error)=>{}
    });
  }

  changeCrmSeetings(data){
    if(['parentChildLevel','ContactTemplate'].includes(data?.code) && !data?.value && data.enabled){
        this.editCsetting(data);
        data.enabled = false;
        return;
    }

    const requestBody = {
      code: data?.code,
      enabled: data?.enabled,
      moduleId: data?.moduleId,
      value: data?.value
    }
    this.configurationService.updateCrmSetting(requestBody).subscribe({
      next: (response)=>{
        this.phoneNumberFormatService.getPhoneNumberFormat(true);
        this.configDefaultService.getAccountTreeViewSettings(true);
        this.configDefaultService.getMergeAccountSequenceNumber(true);
      },
      error: (error)=>{
      }
    });
    if(data.code ==="WorkFlowUserAccess"){
      this.saveAccessControl(data);
    }
  }

  savedSearchWorkflowSettings(){
    this.appMainService.isShowSpinner('getAccessControl');
    this.configurationService.getSavedSearchWorkFlowSettings().subscribe({
      next: (response)=>{
        this.isSavedSearchSettings = true;
        this.accessControlData = response;
        this.accessControlDataCopy = response;

   // Transform accessControlData to match CrmSettingModel
           const transformedAccessControlData: CrmSettingModel[] = this.accessControlData.map(item => ({
            name: item.name,
            enabled: item?.isSelected,
            id: item?.id,
        }));
        this.accessControlData = transformedAccessControlData;
        this.selectedAccessControl = this.accessControlData.find((x) => x.enabled == true);
        this.appMainService.isHideSpinner('getAccessControl');
      },
      error: (error)=>{
        this.appMainService.isHideSpinner('getAccessControl');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message ? error?.error?.Message : 'AcccessControl is not loaded..' });
      }
    });
  }

  saveAccessControl(moduleSettingData: any){
    this.accessControlDataCopy.forEach((control) => {
      if (moduleSettingData.enabled) {
        if (control.id === 1) {
          control.isSelected = true;
        } else if (control.id === 2) {
          control.isSelected = false;
        }
      } else {
        if (control.id === 1) {
          control.isSelected = false;
        } else if (control.id === 2) {
          control.isSelected = true;
        }
      }
    });
        this.appMainService.isShowSpinner('saveAccessControl');
        this.configurationService.setSavedSearchWorkFlowSettings(this.accessControlDataCopy)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.savedSearchWorkflowSettings();
                    this.appMainService.isHideSpinner('saveAccessControl');
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Access Control Updated Successfully' });
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('saveAccessControl');
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message ? error?.error?.Message : 'AcccessControl is not Updated..' });
                }),
                complete: (() => {
                })
            });

}

editCsetting(event){
    this.displaySettingsEdit = true;
    this.selectedSettings = ParseHelper.DeepCopy(event);

    switch(this.selectedSettings.code){
        case 'ContactTemplate':
            this.settingsOptionValues = ParseHelper.DeepCopy(this.allContactFormat);
            break;
        case 'parentChildLevel':
            this.settingsOptionValues = ParseHelper.DeepCopy(this.accountChildLevels);
            break;
    }

    this.selectedSettingOption = this.settingsOptionValues.find(data => data.value === this.selectedSettings.value)||this.settingsOptionValues[0];
}

saveSettings(){
  this.appMainService.isShowSpinner('getAccessControl');
  const requestBody = {
    code: this.selectedSettings?.code,
    enabled: this.selectedSettingOption.value ? this.selectedSettings?.enabled : false,
    moduleId: this.selectedSettings?.moduleId,
    value: this.selectedSettingOption.value
  }
  this.configurationService.updateCrmSetting(requestBody).subscribe({
    next: (response)=>{
      this.appMainService.isHideSpinner('getAccessControl');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Setting saved successfully' });
      this.displaySettingsEdit = false;
      this.phoneNumberFormatService.getPhoneNumberFormat(true);
      this.getSettingsData();
    },
    error: (error)=>{
      this.appMainService.isHideSpinner('getAccessControl');
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message ? error?.error?.Message : 'Failed To Save settings..' });
    }
  });
}

ngOnDestroy() {
  this.ngUnsubscribe.next();
  this.ngUnsubscribe.complete();
}


}
